import { render, staticRenderFns } from "./active-filters.vue?vue&type=template&id=d6981f72&"
import script from "./active-filters.vue?vue&type=script&lang=js&"
export * from "./active-filters.vue?vue&type=script&lang=js&"
import style0 from "./active-filters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports